export default __webpack_public_path__ + "static/media/uz.23ee7586.svg";